<!--上传文件-->
<template>
  <div class="item-box">
    <!--标题-->
    <div :class="['question-item-title',{ isMbottom: question.show_rule.is_check_show },]">
      <span :class="{xinxin:isYes}">
        <i v-if="!$store.state.settingData.base.notorder">{{ number }}、</i>
        <span class="q-title" v-html="question.title"></span>
        <Icon type="ios-information-circle"
              @click="hintShowClick"
              v-if="question.show_rule.is_check_show &&question.show_rule.hint.length > 0 "/>
      </span>
    </div>
    <span class="title-tips"
          v-html="question.show_rule.hint"
          v-if="!question.show_rule.is_check_show">
    </span>
    <div class="q-content">
      <Upload
          ref="upload"
          :disabled="isDisabled"
          :max-size="maxSize"
          :action="apiUrl+'/v1/mobile/form/upload'"
          :before-upload="handerBeforeUpload"
          :on-success="handlePreview"
          :on-remove="handleRemove"
          >
        <div class="uploadBtn">
          <i class="iconfont iconshangchuan"></i>上传文件(不超过4M)
        </div>
      </Upload>
      <div class="imgPreview" v-if="showImg">
        <img :src="filepath" style="width: 100%">
      </div>
      <!-- <div v-else>
        <p>{{ filepath }}</p>
      </div> -->
    </div>
    <!--提示弹框-->
    <Modal class="hintModel" v-model="modal" width="70%" :closable="false">
      <p slot="header">
        <Icon type="ios-information-circle"></Icon>
        <span>填写提示</span>
      </p>
      <div style="color: #4e4c56; font-size: 16px">
        <span v-html="question.show_rule.hint"></span>
      </div>
      <div slot="footer">
        <p @click="clearClick">我知道了</p>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "tUplod",
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    number: {
      type: Number,
      default() {
        return 1
      }
    },
  },
  data() {
    return {
      isDisabled:false,
      modal: false,
      apiUrl: process.env.VUE_APP_BASE_API,
      filepath: '',
      showImg: false,
      // acceptType: '',
      maxSize: null,
      isYes:false
    }
  },
  methods: {
    hintShowClick() {
      this.modal = true
    },
    clearClick() {
      this.modal = false
    },
    handerBeforeUpload(file) {
      console.log(file)
    },
    handlePreview(res, file ,fileList) {
      const selectedNum = this.question.show_rule.uload_number_selectoptions_value
      if(fileList.length === selectedNum)  {
        this.isDisabled = true
        this.$refs.upload.$el.addEventListener('click', () =>{
          this.$Message.warning(`最多只能上传${selectedNum}个文件`)
        })
      }
      let imgType = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (imgType === 'jpg' || imgType === 'jpeg' || imgType === 'png' || imgType === 'gif' || imgType === 'svg') {
        this.showImg = true
      } else {
        this.showImg = false
      }
      this.filepath = this.apiUrl + res.data.path
      let obj = {}
      let fileArr = [];
      fileList.forEach((data,i)=>{
        let url = !this.apiUrl? 'http://cloudforms.cjyun.org/'+ data.response.data.path : this.apiUrl + data.response.data.path;
        fileArr.push(url)
      })
      obj[this.question.id] = fileArr.join(',');
      this.$store.dispatch('userAnswersActions', obj)
    },
    handleRemove(file, fileList){
      console.log(fileList)
    }
  },
  watch: {
    question: {
      handler(newValue, oldValue) {
        this.question = newValue
        this.question.verify_rule !== null ? this.isYes = this.question.verify_rule.is_require : this.isYes = false
      },
      deep: true
    },
    number: {
      handler(newValue, oldValue) {
        this.number = newValue
      },
      deep: true
    }
  },
  mounted() {
    console.log(this.$refs.upload.$el)
    // let acceptTypeArr = []
    // for (let i = 0; i < this.question.show_rule.upload_type_selectoptions_value.length; i++) {
    //   if (this.question.show_rule.upload_type_selectoptions_value[i] === "image") {
    //     acceptTypeArr.push('.jpg', '.png', '.bmp', '.gif')
    //   }
    //   if (this.question.show_rule.upload_type_selectoptions_value[i] === "file") {
    //     acceptTypeArr.push('.doc', '.xls', '.ppt', '.txt', '.pdf')
    //   }
    //   if (this.question.show_rule.upload_type_selectoptions_value[i] === "audio-video") {
    //     acceptTypeArr.push('.mp3', '.mp4', '.wma')
    //   }
    //   if (this.question.show_rule.upload_type_selectoptions_value[i] === "package") {
    //     acceptTypeArr.push('.zip', '.rar', '.7z')
    //   }
    // }
    // this.acceptType = acceptTypeArr.toString()
    this.question.show_rule.upload_type_selectoptions_value
    this.maxSize = this.question.show_rule.upload_size_selectoptions_value * 1024
    this.filepath = this.$store.state.user_answers[this.question.id]
    this.question.verify_rule !== null ? this.isYes = this.question.verify_rule.is_require : this.isYes = false
    const type = this.filepath.replace(/.+\./, "")
    if (type === 'jpg' || type === 'jpeg' || type === 'png' || type === 'gif' || type === 'svg') {
      this.showImg = true
    } else {
      this.showImg = false
    }
  }
}
</script>

<style lang="scss" scoped>
.xinxin {
  position: relative;
  margin-right: 5px;
  padding-left:8px;
  &:after {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    font-size: 16px;
    color: rgb(255, 51, 0);
    position: absolute;
    top: 0px;
    left: 0px;
  }
}
.q-content {
  /deep/ .ivu-upload {
    width: 100%;

    .uploadBtn {
      width: 100%;
      height: 32px;
      line-height: 32px;
      border: 1px dashed #e5e9ed;
      border-radius: 2px;
      text-align: center;

      &:hover {
        cursor: pointer;
      }
    }
  }

    .imgPreview {
    width: 150px;
    //height: 120px;
    //line-height: 120px
  }

  /deep/ .ivu-upload-list-file {
    span {
      font-size: 14px;
    }
  }
}
</style>
